import * as React from "react";
const SvgUndo20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3.126 13H8v2H0V7h2v4.014c.342-.51.783-1.098 1.325-1.69C4.798 7.718 7.108 6 10.25 6s5.452 1.718 6.925 3.324a14.52 14.52 0 0 1 2.082 2.954 8.675 8.675 0 0 1 .139.277l.009.019.002.005.001.003s.001.001-.908.418l.91-.417.416.91-1.818.833-.416-.908-.004-.007a4.256 4.256 0 0 0-.103-.205 12.518 12.518 0 0 0-1.785-2.53C14.423 9.282 12.608 8 10.25 8S6.077 9.282 4.8 10.676A12.518 12.518 0 0 0 3.126 13Z",
      clipRule: "evenodd"
    })
  );
export default SvgUndo20Px;
